import PreloadIndicatorController from './PreloadIndicatorController';
import registerPreloadIndicatorDirective from './PreloadIndicatorDirective';

/**
 * Register preload indicator component with AngularJS
 */
export default function registerPreloadIndicatorComponent(angular) {
    const directivesModule = angular.module('assessmentFrontendDirectives');
    directivesModule.controller('PreloadIndicatorController', PreloadIndicatorController);
    registerPreloadIndicatorDirective(directivesModule);
}
